import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.links}>
                <a href="#">凤凰新媒体介绍</a><span className={styles.divider}>|</span>
                <a href="#">投资者关系 Investor Relations</a><span className={styles.divider}>|</span>
                <a href="#">广告服务</a><span className={styles.divider}>|</span>
                <a href="#">诚征英才</a><span className={styles.divider}>|</span>
                <a href="#">保护隐私权</a><span className={styles.divider}>|</span>
                <a href="#">免责条款</a><span className={styles.divider}>|</span>
                <a href="#">意见反馈</a><span className={styles.divider}>|</span>
                <a href="#">凤凰卫视介绍</a>
            </div>
            <div>
                <span className={styles.span}>凤凰新媒体</span>
                <span className={styles.span}>版权所有</span>
                Copyright © 2022 Phoenix New Media Limited All Rights Reserved.
            </div>
        </div>
    );
};

export default errorBoundary(Footer);
